
export const NodeTypes = {
        account: "account",
        client: "client",
        root: "root"
    }

export const defualtTableProps = {
    muiTableHeadCellProps: {
        sx: {
            color: 'var(--text)',
            paddingTop: '0',
            paddingBottom: '0',
            //paddingLeft: '0',
            //paddingRight:'0',
            '& svg': {
                fill: 'var(--text)',
            },
            '& th': {
                padding: '0'
            },
            '&:focus-visible': {
                outline: 'none'
            }
            //,
            //'& .MuiTableSortLabel-root': {
            //    display:'none'
            //}
        },
    },
    muiTopToolbarProps: {
        sx: {
            '& svg': {
                fill: 'var(--text)',
            },
        },
    },
    muiTableProps: {
        sx: {
            color: 'var(--text)'
        },
    },
    muiToolbarAlertBannerProps: {
        sx: {
            backgroundColor: 'var(--bg) !important',
        },
    },
    muiTableBodyRowProps: {
        sx: {
            backgroundColor: 'var(--bg) !important'
        },
    },
    muiTableFooterRowProps: {
        sx: {
            backgroundColor: 'var(--bg-lighter) !important'
        },
    },
    muiTablePaperProps: {
        elevation: 0, //change the mui box shadow
        //customize paper styles
        sx: {
            background: 'var(--bg)',
            color: 'var(--text)',
        },
    },
}
export const defaultMantineTableProps = {
    mantineTableHeadCellProps: {
        sx: {
            color: 'var(--text)',
            paddingTop: '0',
            paddingBottom: '0',
            '& svg': {
                fill: 'var(--text)',
            },
        },
    },
    mantineTopToolbarProps: {
        sx: {
            '& svg': {
                fill: 'var(--text)',
            },
            '& ': {
                backgroundColor:'var(--bg-lighter)'
            }
        },
    },
    mantineTableProps: {
        sx: {
            '& ': {
                backgroundColor: 'var(--bg-lighter)'
            },
            color: 'var(--text)'
        },
        
    },
    mantineTableHeadProps: {
        sx: {
            '& th': {
                backgroundColor: 'var(--bg-lighter)',
                color: 'var(--text) !important'
            },
        }
    },
    mantineToolbarAlertBannerProps: {
        sx: {
            backgroundColor: 'var(--bg) !important',
        },
    },
    mantineTableBodyRowProps: {
        sx: {
            backgroundColor: 'var(--bg) !important'
        },
    },
    mantineTableFooterRowProps: {
        sx: {
            backgroundColor: 'var(--bg-lighter) !important'
        },
    },
    mantineSelectAllCheckboxProps: {
        sx: {
            '& input': {
                color: 'var(--selected)',
                border: '.15rem solid var(--text)',
                background: 'transparent',
            },
            '& input:checked': {
                background: 'var(--selected)',
                border: 'none'
            }
        },
    }
}
export const clientsTreeNode = {
    id: "",
    name: "",
    parentId: "",
    type: ""
}

export const dateComparator = (valueA, valueB) =>  {
    if (valueA == null) {
        return valueB == null ? 0 : -1;
    }
    if (valueB == null) {
        return 1;
    }

    const dateA = new Date(valueA);
    const dateB = new Date(valueB);
    if (dateA < dateB) {
        return -1;
    } else if (dateA > dateB) {
        return 1;
    } else {
        return 0;
    }
}